// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ReplicationDetailsGraphQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  replicationFollowerId: Types.Scalars["String"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type ReplicationDetailsGraphQuery = {
  __typename?: "GraphqlQuery";
  getReplicationFollowerStats?: {
    __typename?: "ReplicationFollowerStats";
    totalByteLag?: Array<Array<number | null> | null> | null;
    remoteByteLag?: Array<Array<number | null> | null> | null;
    localByteLag?: Array<Array<number | null> | null> | null;
  } | null;
};

export const ReplicationDetailsGraphDocument = gql`
  query ReplicationDetailsGraph(
    $serverId: ID!
    $replicationFollowerId: String!
    $startTs: Int!
    $endTs: Int!
  ) {
    getReplicationFollowerStats(
      serverId: $serverId
      replicationFollowerId: $replicationFollowerId
      startTs: $startTs
      endTs: $endTs
    ) {
      totalByteLag
      remoteByteLag
      localByteLag
    }
  }
`;

/**
 * __useReplicationDetailsGraphQuery__
 *
 * To run a query within a React component, call `useReplicationDetailsGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplicationDetailsGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplicationDetailsGraphQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      replicationFollowerId: // value for 'replicationFollowerId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useReplicationDetailsGraphQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReplicationDetailsGraphQuery,
    ReplicationDetailsGraphQueryVariables
  > &
    (
      | { variables: ReplicationDetailsGraphQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReplicationDetailsGraphQuery,
    ReplicationDetailsGraphQueryVariables
  >(ReplicationDetailsGraphDocument, options);
}
export function useReplicationDetailsGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReplicationDetailsGraphQuery,
    ReplicationDetailsGraphQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReplicationDetailsGraphQuery,
    ReplicationDetailsGraphQueryVariables
  >(ReplicationDetailsGraphDocument, options);
}
// @ts-ignore
export function useReplicationDetailsGraphSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReplicationDetailsGraphQuery,
    ReplicationDetailsGraphQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ReplicationDetailsGraphQuery,
  ReplicationDetailsGraphQueryVariables
>;
export function useReplicationDetailsGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReplicationDetailsGraphQuery,
        ReplicationDetailsGraphQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ReplicationDetailsGraphQuery | undefined,
  ReplicationDetailsGraphQueryVariables
>;
export function useReplicationDetailsGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ReplicationDetailsGraphQuery,
        ReplicationDetailsGraphQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ReplicationDetailsGraphQuery,
    ReplicationDetailsGraphQueryVariables
  >(ReplicationDetailsGraphDocument, options);
}
export type ReplicationDetailsGraphQueryHookResult = ReturnType<
  typeof useReplicationDetailsGraphQuery
>;
export type ReplicationDetailsGraphLazyQueryHookResult = ReturnType<
  typeof useReplicationDetailsGraphLazyQuery
>;
export type ReplicationDetailsGraphSuspenseQueryHookResult = ReturnType<
  typeof useReplicationDetailsGraphSuspenseQuery
>;
export type ReplicationDetailsGraphQueryResult = Apollo.QueryResult<
  ReplicationDetailsGraphQuery,
  ReplicationDetailsGraphQueryVariables
>;
